import React, { useEffect } from 'react';

interface LandingProps {
  onStartChat?: () => void;
  onStateChange?: (state: string) => void;
}

export function Landing({ onStartChat, onStateChange }: LandingProps) {
  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event: MessageEvent) => {
      // Make sure message is from our iframe
      if (event.origin !== window.location.origin) return;

      // Handle messages from the landing page
      if (event.data === 'talk' || event.data.state === 'talk') {
        if (onStartChat) {
          onStartChat();
        }
        if (onStateChange) {
          onStateChange('talk');
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onStartChat, onStateChange]);

  return (
    <iframe 
      src="/landing/index.html"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 25 // Between visualization (1) and overlay (50)
      }}
    />
  );
}
